import Swal from 'sweetalert2'

export default {
    methods: {
        showSwal(title, type = 'warning', text) {
            return Swal({ title, type, text })
        },
    },
}
